import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ACTIVITIES_LIST_COLUMNS } from '../../../../school/lists/list-display/list-display-activity/list-display-activity.component';
import { LIST_TYPE } from '../../../../shared/constants/list-view/list-view.constant';
import { unsubscribeComponent } from '../../../../shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { IActivitiesModalComponentData } from '../../../../shared/modals/activities/activities-modal.component';
import { ModalsService } from '../../../../shared/modals/modals.service';
import { ActivitiesGrouping } from '../../../../shared/services/mad-lib-services/grouping-functions/postsec-groupings/activities-groupings';
import { IActivity } from '../../../../shared/typings/interfaces/activity.interface';
import { ISchool } from '../../../../shared/typings/interfaces/school.interface';

@Component({
  selector: 'activities-settings',
  template: require('./activities-settings.component.html'),
  styles: [require('./activities-settings.component.scss')],
})
@unsubscribeComponent
export class ActivitiesSettingsComponent implements OnInit {
  @Input() activities$: Observable<IActivity[]>;
  @Input() school: ISchool;

  public activities: IActivity[];
  public formattedActivities$;

  constructor(private activitiesGroupings: ActivitiesGrouping, private modalsService: ModalsService) {
    // empty block
  }

  ngOnInit() {
    this.formatListData(this.activities$);

    // subscribe to activities so they can be passed to list-display-activites (JE)
    this.activities$.subscribe(activities => {
      this.activities = activities;
    });
  }

  formatListData(activities: Observable<IActivity[]>): void {
    let x = this.activitiesGroupings.getActivitiesGrouping(activities, ACTIVITIES_LIST_COLUMNS, LIST_TYPE.ACTIVITIES);
    this.formattedActivities$ = x;
  }

  openActivityModal() {
    const opts: IActivitiesModalComponentData = {
      mode: 'CREATE',
      schoolId: this.school._id,
      isProfileMode: true,
    };
    this.modalsService.openActivitiesModal(opts);
  }
}
